import * as React from 'react';
import { actionCreators as shellActions } from 'app/shell/default/actions';
import { containerFactory } from 'app/infrastructure/redux';
import { STATE } from 'app/constants';
import styles from './sticky-header.scss';

interface StickyHeaderProps {
  className?: string;
  updateFixedHeaderStatus?: (fixed: boolean) => void;
  id?: string;
  disabled?: boolean;
  rightSideContent?: any;
  children?: React.ReactNode;
}

const StickyHeader: React.FC<StickyHeaderProps> = (props: StickyHeaderProps) => {
  const { children, className, id, disabled, rightSideContent } = props;
  const htmlProps = { id };

  React.useEffect(() => {
    if (!props.disabled) {
      props.updateFixedHeaderStatus(false);
    }

    return () => {
      if (!props.disabled) {
        props.updateFixedHeaderStatus(true);
      }
    };
  }, []);

  return <div className={`${className || ''} ${styles.header} ${!disabled ? styles.sticky + ' sticky' : ''}`} {...htmlProps}>
    <div className={`main-grid ${styles.wrapper}`}>
      <div className={styles.left}>
        {children}
      </div>
      {rightSideContent}
    </div>
  </div>;
};
//@ts-ignore
StickyHeader.statePath = STATE.app;
const container = containerFactory<StickyHeaderProps>(
  StickyHeader,
  shellActions,
  null,
  null) as any;

export { container as StickyHeader };

export const StickyHeaderButtonContainer = ({ children }) => <div className={styles.buttonContainer}>{children}</div>;
